import React, { useState } from 'react';
import '../../../App.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { SERVER_URL } from '../../../Config';
import toast from "react-hot-toast";


export default function ChangePassword() {
    const [showOldPassword, setShowOldPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [oldPassword, setOldPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [loading, setLoading] = useState(false);

    const adminData = JSON.parse(sessionStorage.getItem('admin')); 
    const email = adminData?.email || '';

    const toggleOldPassword = () => setShowOldPassword(!showOldPassword);
    const toggleNewPassword = () => setShowNewPassword(!showNewPassword);
    const handleChangePassword = async () => {
        if (!oldPassword || !newPassword) {
            alert('Please fill in all fields.');
            return;
        }

        setLoading(true);

        try {
            const response = await fetch(`${SERVER_URL}/api/changepassword`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email, oldPassword, newPassword })
            });

            const data = await response.json();
            if (data.success) {
                toast.success('Password changed successfully!');
                setOldPassword('');
                setNewPassword('');
            } else {
                toast.error(data.message);
            }
        } catch (error) {
            console.error('Error:', error);
            toast.error('An error occurred. Please try again.');
        }

        setLoading(false);
    };

    return (
        <div className='p-5 flex flex-col md:min-h-[85vh]'>
            <h1 className='font-Artemus text-xl'>Change password</h1>
            <div className='flex flex-1 items-center justify-center w-[100%] h-full'>
                <div className='p-7 bg-[#1E1E1E] border-2 border-[#ECEEF6] rounded-2xl w-[90%] md:w-[60%] lg:w-[40%] space-y-5'>
                    <div className="relative">
                        <input
                            type={showOldPassword ? 'text' : 'password'}
                            className='w-[100%] rounded-md bg-gradient-to-r from-[#59594f] to-[#252524] outline-none py-2 px-3 pr-10'
                            placeholder='Enter Old Password'
                            value={oldPassword}
                            onChange={(e) => setOldPassword(e.target.value)}
                        />
                        <FontAwesomeIcon
                            icon={showOldPassword ? faEye : faEyeSlash}
                            className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 cursor-pointer"
                            onClick={toggleOldPassword}
                        />
                    </div>

                    <div className="relative">
                        <input
                            type={showNewPassword ? 'text' : 'password'}
                            className='w-[100%] rounded-md bg-gradient-to-r from-[#59594f] to-[#252524] outline-none py-2 px-3 pr-10'
                            placeholder='Enter New Password'
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                        />
                        <FontAwesomeIcon
                            icon={showNewPassword ? faEye : faEyeSlash}
                            className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 cursor-pointer"
                            onClick={toggleNewPassword}
                        />
                    </div>

                    <div className='flex justify-center pt-3'>
                        <button className='bg-[#151515] rounded-full px-5 py-1 font-Artemus border border-[#FFFFD952] inner-shadow' onClick={handleChangePassword}
                            disabled={loading}>
                            Change Password
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
